export class SearchResponse {
  teams: TeamSearchItemResult[] = [];
  titles: TitleSearchItemResult[] = [];
  users: UserSearchItemResult[] = [];
}

export interface TeamSearchItemResult {
  type: 'team';
  teamId: string;
  displayName: string;
  username?: string;
  profilePictureUri?: string;
}

export interface TitleSearchItemResult {
  description: string;
  oddrLink: string;
  thumbnailUri: string;
  title: string;
}

export interface UserSearchItemResult {
  type: 'user';
  profilePictureUri: string;
  profileUrl: string;
  username: string;
}
